export default function PortfolioSection() {
  const stories = [
    {
      name: "Анна К.",
      city: "Москва",
      income: "380₽/час",
      time: "работает 8 месяцев",
      quote: "Пришла вообще без опыта — никогда не работала в чатах. Наставница всё объяснила за 3 дня, на стажировке уже вела реальные диалоги. Сейчас получаю 380₽/час, работаю по 6 часов в день из дома.",
      tags: ["Без опыта", "Смены 5/2"],
      img: "https://readdy.ai/api/search-image?query=happy%20young%20russian%20woman%20working%20from%20home%20on%20laptop%20with%20chat%20interface%20on%20screen%2C%20bright%20cozy%20home%20office%20with%20blue%20white%20tones%2C%20natural%20light%2C%20smiling&width=400&height=300&seq=ws-port1&orientation=landscape",
    },
    {
      name: "Игорь М.",
      city: "Новосибирск",
      income: "380₽/час",
      time: "работает 1 год",
      quote: "Раньше работал в колл-центре за 35 000 в месяц. Здесь перешёл на чаты — нагрузка ниже, а зарплата выше. Плюс не надо никуда ездить. В месяц выходит около 60 000 чистыми.",
      tags: ["Опыт в поддержке", "Смены 4/2"],
      img: "https://readdy.ai/api/search-image?query=confident%20russian%20male%20professional%20working%20remotely%20on%20laptop%20with%20chat%20messages%20visible%2C%20bright%20modern%20apartment%20blue%20white%20minimalist%20interior%2C%20smiling&width=400&height=300&seq=ws-port2&orientation=landscape",
    },
    {
      name: "Светлана Р.",
      city: "Екатеринбург",
      income: "380₽/час",
      time: "работает 5 месяцев",
      quote: "Я мама в декрете. Нужна была работа, которую можно совмещать с ребёнком. График 4/2 — идеально. Обучение оплатили, стажировка тоже. Сейчас стабильно выходит 45-50 тысяч в месяц.",
      tags: ["Декрет", "График 4/2"],
      img: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20working%20remotely%20from%20bright%20home%20desk%20with%20chat%20support%20screen%2C%20blue%20white%20modern%20workspace%2C%20young%20mother%20smiling&width=400&height=300&seq=ws-port3&orientation=landscape",
    },
    {
      name: "Павел Д.",
      city: "Краснодар",
      income: "380₽/час",
      time: "работает 3 месяца",
      quote: "До этого три года работал курьером — устал от дороги и погоды. Друг посоветовал WorkTerra. Прошёл обучение за 5 дней, уже работаю. Зарплата такая же, но сижу дома в тепле.",
      tags: ["Смена профессии", "Без опыта"],
      img: "https://readdy.ai/api/search-image?query=middle%20aged%20russian%20man%20working%20from%20bright%20home%20office%20on%20computer%20with%20chat%20interface%2C%20blue%20white%20clean%20minimalist%20workspace%2C%20relaxed%20atmosphere&width=400&height=300&seq=ws-port4&orientation=landscape",
    },
    {
      name: "Ольга В.",
      city: "Казань",
      income: "380₽/час",
      time: "работает 2 года",
      quote: "Начинала с обычной ставки 380₽/час. Через полгода подняли до 420 за качество. Сейчас я уже старший оператор — помогаю новичкам, проверяю чаты. Очень довольна ростом.",
      tags: ["Повышение ставки", "Карьерный рост"],
      img: "https://readdy.ai/api/search-image?query=happy%20russian%20woman%20in%20her%2030s%20working%20from%20home%20on%20laptop%2C%20bright%20sunny%20room%20blue%20white%20interior%2C%20professional%20chat%20operator%2C%20confident%20smile&width=400&height=300&seq=ws-port5&orientation=landscape",
    },
    {
      name: "Роман Т.",
      city: "Санкт-Петербург",
      income: "380₽/час",
      time: "работает 10 месяцев",
      quote: "Учусь в университете, нужна была подработка. Взяли без опыта, обучили. Беру вечерние смены после пар — 4-5 часов в день. В месяц выходит около 35 000, для студента отлично.",
      tags: ["Студент", "Подработка"],
      img: "https://readdy.ai/api/search-image?query=young%20russian%20male%20student%20working%20on%20laptop%20with%20chat%20support%20from%20bright%20dorm%20room%2C%20blue%20white%20modern%20minimalist%20workspace%2C%20headphones%2C%20happy&width=400&height=300&seq=ws-port6&orientation=landscape",
    },
  ];

  return (
    <section id="portfolio" className="relative py-24 lg:py-32 overflow-hidden bg-background-100">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-4 bg-primary-100 text-primary-700">
            Наши операторы
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            Реальные истории{" "}
            <span className="text-primary-500">наших сотрудников</span>
          </h2>
          <p className="text-foreground-600 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            Более 800 операторов уже работают с нами. Вот что они сами рассказывают о работе в WorkTerra.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stories.map((story) => (
            <div
              key={story.name}
              className="rounded-2xl overflow-hidden bg-background-50 border border-primary-100 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  alt={story.name}
                  className="w-full h-full object-cover object-top"
                  src={story.img}
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <h4 className="text-foreground-950 font-semibold text-base">
                      {story.name}
                    </h4>
                    <p className="text-foreground-500 text-xs mt-0.5">
                      {story.city}
                    </p>
                  </div>
                  <div className="text-right">
                    <div className="text-primary-600 font-bold text-sm">
                      {story.income}
                    </div>
                    <div className="text-foreground-500 text-xs">{story.time}</div>
                  </div>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {story.quote}
                </p>
                <div className="flex flex-wrap gap-2">
                  {story.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full text-xs bg-secondary-100 text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}